// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cIYD_awNBHYfRhusV0Sg{flex-shrink:0;height:136px}`, "",{"version":3,"sources":["webpack://./../../components/react/src/components/Footer/footer.module.scss"],"names":[],"mappings":"AAAA,sBACE,aAAA,CACA,YAAA","sourcesContent":[".root {\n  flex-shrink: 0;\n  height: 136px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `cIYD_awNBHYfRhusV0Sg`
};
export default ___CSS_LOADER_EXPORT___;
